import { render, staticRenderFns } from "./PostControl.vue?vue&type=template&id=4f8b1a17&scoped=true&"
import script from "./PostControl.vue?vue&type=script&lang=js&"
export * from "./PostControl.vue?vue&type=script&lang=js&"
import style0 from "./PostControl.vue?vue&type=style&index=0&id=4f8b1a17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b1a17",
  null
  
)

export default component.exports